import React from 'react';
import { motion } from 'framer-motion';
import './About.css';

const About = () => {
  const stats = [
    { label: '成立', value: '2020', description: '聚焦工程领域数字化' },
    { label: '核心成员背景', value: '知名大厂', description: '企业级产品与工程经验' },
    { label: '服务企业', value: '200+ 家', description: '覆盖基建、房建、市政' },
    { label: '效率提升', value: '40%+', description: '平均项目效率提升' }
  ];

  const advantages = [
    { title: '技术实力', description: '核心团队来自知名科技企业，具备云原生、大数据、AI 能力沉淀。' },
    { title: '行业理解', description: '深度理解工程企业管理痛点，产品功能贴合实际业务，解决真实问题。' },
    { title: '客户成功', description: '服务数百家工程企业，帮助客户实现效率、成本、风险的全面提升。' },
    { title: '持续创新', description: '紧跟行业趋势，迭代数字化中台、AI 助手等产品，坚持技术领先。' },
    { title: '专业服务', description: '提供咨询、实施、运营一站式服务，设立客户成功团队陪跑。' }
  ];

  const values = [
    { title: '专业专注', description: '专注工程行业数字化场景，深入理解客户业务。' },
    { title: '创新驱动', description: '以技术创新为引擎，持续打造行业领先产品。' },
    { title: '客户至上', description: '以客户成功为最终目标，用数据衡量交付价值。' },
    { title: '诚信合作', description: '与伙伴共建生态，打造互信、共赢的长期关系。' },
    { title: '追求卓越', description: '对产品与服务精益求精，持续迭代用户体验。' }
  ];

  const teamMembers = [
    { name: '徐总', title: '创始人兼 CEO', desc: '某知名事务所负责人，主导多个大型数字化项目' },
    { name: '熊经理', title: '技术总监', desc: '某大学知名教授，专注云原生与数据中台设计' },
    { name: '金专家', title: '行业顾问', desc: '20 年工程管理经验，熟悉大型基建与市政项目流程' }
  ];

  return (
    <div className="about">
      <motion.section
        className="hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <motion.p
            className="eyebrow"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            style={{ color: '#80B7FF' }}
          >
            ABOUT XINGSHENG
          </motion.p>
          <motion.h1
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            用数字化能力重构工程行业的运营方式
          </motion.h1>
          <motion.p
            className="intro"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            星晟工程数字管理有限公司是一家专注工程领域的高科技企业，总部位于宁波。我们通过先进的技术与深厚的行业理解，帮助工程企业构建可视、可控、可预测的数字化管理体系。
          </motion.p>
        </div>
      </motion.section>

      <motion.section
        className="stats"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "0px 0px -100px 0px" }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <motion.div
                className="stat-card"
                key={stat.label}
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 * index }}
              >
                <span className="value">{stat.value}</span>
                <span className="label" style={{ color: '#111111' }}>{stat.label}</span>
                <p>{stat.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>

      <motion.section
        className="company-info"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "0px 0px -100px 0px" }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <div className="info-grid">
            <motion.div
              className="info-block"
              initial={{ x: -30, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <p className="eyebrow">公司简介</p>
              <h2>关于星晟</h2>
              <p>
                星晟工程数字管理有限公司是一家专注于工程领域数字化解决方案的高科技企业。我们深度理解工程企业在项目、合同、资金、流程上的管理难题，通过自研的工程数智管控平台，为客户提供全方位的数字化管理工具与咨询服务。
              </p>
              <p>
                核心团队成员来自知名大厂等科技企业，拥有丰富的企业级软件与工程行业经验。我们坚持以客户为中心，通过技术创新和产品迭代，帮助客户实现数字化转型，提升管理效率、降低运营成本、增强核心竞争力。
              </p>
            </motion.div>
            <motion.div
              className="info-block"
              initial={{ x: 30, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <h3>使命与愿景</h3>
              <p>使命：推动工程建设行业的数字化升级，让每一个项目都“看得见、控得住、算得清”。</p>
              <p>愿景：成为工程领域最受信赖的数字化合作伙伴，与客户共同打造可持续发展的行业生态。</p>
              <div className="advantage-list">
                {advantages.map((item, index) => (
                  <motion.div
                    className="advantage-card"
                    key={item.title}
                    initial={{ y: 20, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.4 + index * 0.1 }}
                  >
                    <h4>{item.title}</h4>
                    <p>{item.description}</p>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </motion.section>

      <motion.section
        className="values"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "0px 0px -100px 0px" }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <div className="section-header">
            <motion.p
              className="eyebrow"
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              CORE VALUES
            </motion.p>
            <motion.h2
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              我们的价值观
            </motion.h2>
            <motion.p
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              用清晰的价值观指导产品设计、客户服务与团队协作。
            </motion.p>
          </div>
          <div className="value-grid">
            {values.map((value, index) => (
              <motion.div
                className="value-card"
                key={value.title}
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 * index }}
              >
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>

      <motion.section
        className="team"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "0px 0px -100px 0px" }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <div className="section-header">
            <motion.p
              className="eyebrow"
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              LEADERSHIP
            </motion.p>
            <motion.h2
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              与行业专家一起打造产品
            </motion.h2>
            <motion.p
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              跨学科团队覆盖产品、技术、工程管理与客户成功，确保方案可落地、可复制。
            </motion.p>
          </div>
          <div className="team-grid">
            {teamMembers.map((member, index) => (
              <motion.div
                className="team-member"
                key={member.name}
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 * index }}
              >
                <div className="member-avatar">{member.name.slice(0, 1)}</div>
                <h3>{member.name}</h3>
                <p className="title">{member.title}</p>
                <p className="desc">{member.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>
    </div>
  );
};

export default About;